export const types = {
  GET_OPERATIONAL_DASHBOARD: " GET_OPERATIONAL_DASHBOARD",
  GET_OPERATIONAL_DASHBOARD_SUCCESS: " GET_OPERATIONAL_DASHBOARD_SUCCESS",
};
